import React from "react";

const TransferWalletToWallet = () => {
  return <div>TransferWalletToWallet</div>;
};
export default TransferWalletToWallet;
